import type { BlockNode } from '../types';

export const PINNED_NAVBAR_ID = 'site-navbar-pinned';
export const PINNED_FOOTER_ID = 'site-footer-pinned';

export function createDefaultSiteNavbar(siteName = 'Apex Coaching Academy'): BlockNode {
  return {
    id: PINNED_NAVBAR_ID,
    type: 'SiteNavbar',
    category: 'layout',
    props: {
      variant: 'classic',
      brandName: siteName,
      logoText: siteName.slice(0, 2).toUpperCase() || 'AC',
      tagline: 'IIT-JEE · NEET · Foundation',
      ctaText: 'Student Login / Enroll',
      ctaLink: '#enroll',
      phone: '+91 98765 43210',
      sticky: true,
      accentColor: '#2563eb',
      bgColor: '#ffffff',
      textColor: '#0f172a',
    },
    styles: { base: {} },
    customName: 'Permanent Site Header (Navbar)',
    locked: true,
  };
}

export function createDefaultSiteFooter(siteName = 'Apex Coaching Academy'): BlockNode {
  return {
    id: PINNED_FOOTER_ID,
    type: 'SiteFooter',
    category: 'layout',
    props: {
      variant: 'multicolumn',
      brandName: siteName,
      description: 'Premier coaching institute empowering students to achieve top national ranks in JEE, NEET, and Olympiad examinations.',
      address: 'Knowledge Park, Sector 62, New Delhi - 110001',
      phone: '+91 98765 43210',
      email: 'admissions@academy.edu.in',
      copyrightText: '© 2026 All Rights Reserved.',
      bgColor: '#0f172a',
      textColor: '#f8fafc',
      accentColor: '#3b82f6',
    },
    styles: { base: {} },
    customName: 'Permanent Site Footer',
    locked: true,
  };
}

/**
 * Ensures that the root container always starts with a SiteNavbar at index 0
 * and ends with a SiteFooter at the last index.
 * Non-deletable chrome required by Requirement 5.
 */
export function ensureSiteChromeNodes(root: BlockNode, siteName?: string): BlockNode {
  const children = root.children ? [...root.children] : [];

  // Find existing navbar and footer
  const navbarIdx = children.findIndex((c) => c.type === 'SiteNavbar');
  let navbarNode: BlockNode;
  if (navbarIdx >= 0) {
    navbarNode = { ...children[navbarIdx], locked: true };
    children.splice(navbarIdx, 1);
  } else {
    navbarNode = createDefaultSiteNavbar(siteName);
  }

  const footerIdx = children.findIndex((c) => c.type === 'SiteFooter');
  let footerNode: BlockNode;
  if (footerIdx >= 0) {
    footerNode = { ...children[footerIdx], locked: true };
    children.splice(footerIdx, 1);
  } else {
    footerNode = createDefaultSiteFooter(siteName);
  }

  // Prepend navbar and append footer
  return {
    ...root,
    children: [navbarNode, ...children, footerNode],
  };
}
